import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import NavMenu from './NavMenu';
import Referrer from './Referrer';
import css from '../../../css/css-variables.json';
import { ENABLE_ORG_MANAGEMENT } from '../constants';
import SwitchProfile from '../containers/SwitchProfile';
import { useViewport } from '../hooks/viewport';

const Nav = styled.nav`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;
  min-width: 16.375em;
  max-width: 22em;
  background-color: #fbfbfb;
  border-right-style: solid;
  border-right-color: ${css.colors.Border};
  border-right-width: 2px;
  order: 0;
  min-height: 23.875em;
  transition-property: all;
  transition-timing-function: ease;
  transition-duration: 0.75s;

  @media(max-width: 720px) {
    display: none;
  }

  @media(max-width: 858px) {
    min-width: 13.750em;
  }
`;

const SideBar = props => {
  const { location, processMenuTree, referredBy, isLoggedIn } = props;
  const { isMobile } = useViewport();

  return (
    <Nav>
      <Referrer referredBy={referredBy} />
      <NavMenu location={location} processMenuTree={processMenuTree} noRender={isMobile} isLoggedIn={isLoggedIn} />
      {ENABLE_ORG_MANAGEMENT && <SwitchProfile />}
    </Nav>
  );
};

const { bool, object, func, string } = PropTypes;

SideBar.propTypes = {
  isLoggedIn: bool,
  processMenuTree: func,
  location: object.isRequired,
  referredBy: string
};

export default SideBar;
